import React, { useState } from 'react';
import './styles/QueryForm.css';

const QueryForm = ({ onSubmit, isLoading }) => {
  const [query, setQuery] = useState('');
  const MAX_WORDS = 10;

  const handleSubmit = (e) => {
    e.preventDefault();
    const wordCount = query.trim().split(/\s+/).length;
    if (wordCount > MAX_WORDS) {
      alert(`⚠️ Text limit is ${MAX_WORDS} words for demo purpose. Your query has ${wordCount} words.`);
      return;
    }
    onSubmit(query);
    setQuery('');
  };

  const handleChange = (e) => {
    const text = e.target.value;
    const wordCount = text.trim() ? text.trim().split(/\s+/).length : 0;
    if (wordCount <= MAX_WORDS) {
      setQuery(text);
    }
  };

  const wordCount = query.trim() ? query.trim().split(/\s+/).length : 0;

  const exampleQuestions = [
    'What is the role of cloud in AI',
    'How cloud impact AI market',
    'What is the future of cloud in the AI era',
  ];

  const handleExample = (example) => {
    const wordCount = example.trim().split(/\s+/).length;
    if (wordCount <= MAX_WORDS) {
      setQuery(example);
    } else {
      alert(`⚠️ Example exceeds ${MAX_WORDS}-word limit.`);
    }
  };

  return (
    <div className="query-form-container">
      <form onSubmit={handleSubmit} className="query-form">
        <div className="input-group">
          <input
            type="text"
            value={query}
            onChange={handleChange}
            disabled={isLoading}
            placeholder="Ask any questions you have (max 10 words)..."
            className="query-input"
          />
          <div className="word-count desktop-only">
            {wordCount}/{MAX_WORDS} words
          </div>
          <button 
            type="submit" 
            disabled={isLoading || !query.trim()}
            className="submit-button"
          >
            {isLoading ? '⏳ Processing...' : '🚀 Send'}
          </button>
        </div>
        <div className="demo-note desktop-only">
          📝 Text limit is {MAX_WORDS} words for demo purpose
        </div>
      </form>

      {/* Desktop: button grid */}
      <div className="examples desktop-only">
        <p className="examples-label">💡 Try these examples:</p>
        <div className="examples-grid">
          {exampleQuestions.map((example, i) => (
            <button
              key={i}
              onClick={() => handleExample(example)}
              disabled={isLoading}
              className="example-button"
              title={example}
            >
              {example}
            </button>
          ))}
        </div>
      </div>

      {/* Mobile: dropdown */}
      <div className="examples-dropdown mobile-only">
        <select
          onChange={(e) => { if (e.target.value) { handleExample(e.target.value); e.target.value = ''; } }}
          disabled={isLoading}
          className="examples-select"
          defaultValue=""
        >
          <option value="" disabled>💡 Try an example question...</option>
          {exampleQuestions.map((example, i) => (
            <option key={i} value={example}>{example}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default QueryForm;
